import IdColumn from './IdColumn';
import NameColumn from './NameColumn';
import SettingsColumn from './SettingsColumn';
import PlatformColumn from "./PlatformColumn";
import ActionsColumn from "./ActionsColumn";
import FormatColumn from "./FormatColumn";
import NumberOfProductsColumn from "./NumberOfProductsColumn";
import FilenameColumn from "./FilenameColumn";
import LastExportColumn from "./LastExportColumn";
import ScheduleColumn from "./ScheduleColumn";

// Column renderer factory
const createFeedExportColumnRenderers = () => ({
  'id': (props) => <IdColumn {...props} />,
  'name': (props) => <NameColumn {...props} />,
  'settings': (props) => <SettingsColumn {...props} />,
  'actions': (props) => <ActionsColumn {...props} />,
  'format': (props) => <FormatColumn {...props} />,
  'filename': (props) => <FilenameColumn {...props} />,
  'number_of_products': (props) => <NumberOfProductsColumn {...props} />,
  'last_export': (props) => <LastExportColumn {...props} />,
  'platform': (props) => <PlatformColumn {...props} />,
  'schedule': (props) => <ScheduleColumn {...props} />,
});

export {
  IdColumn,
  NameColumn,
  SettingsColumn,
  PlatformColumn,
  ActionsColumn,
  FormatColumn,
  NumberOfProductsColumn,
  FilenameColumn,
  LastExportColumn,
  ScheduleColumn,
  createFeedExportColumnRenderers
};
